// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/minimize.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/expand_more.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordian-header button {
  padding: 8px;
  background-color: transparent !important;
}

.accordian-header button:focus {
  box-shadow: none;
  opacity: 1;
}

.accordion-button:not(.collapsed) {
  background-color: transparent !important;
}

.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  width: 17px !important;
  height: 17px !important;
  background-size: 17px !important;
}

.accordion-button.collapsed::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  width: 17px !important;
  height: 17px !important;
  background-size: 17px !important;
}

.accordion-collapse {
  visibility: inherit !important;
  overflow: hidden !important; /* Ensure content doesn't overflow during transition */
  transition: 0.5s ease-in-out !important; /* Add smooth transition */
  transition-property: visibility;
}
`, "",{"version":3,"sources":["webpack://./src/components/accordian/accordian.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oEAAoE;EACpE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,oEAAuE;EACvE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B,EAAE,sDAAsD;EACnF,uCAAuC,EAAE,0BAA0B;EACnE,+BAA+B;AACjC","sourcesContent":[".accordian-header button {\n  padding: 8px;\n  background-color: transparent !important;\n}\n\n.accordian-header button:focus {\n  box-shadow: none;\n  opacity: 1;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: transparent !important;\n}\n\n.accordion-button:not(.collapsed)::after {\n  background-image: url('../../assets/images/minimize.svg') !important;\n  width: 17px !important;\n  height: 17px !important;\n  background-size: 17px !important;\n}\n\n.accordion-button.collapsed::after {\n  background-image: url('../../assets/images/expand_more.svg') !important;\n  width: 17px !important;\n  height: 17px !important;\n  background-size: 17px !important;\n}\n\n.accordion-collapse {\n  visibility: inherit !important;\n  overflow: hidden !important; /* Ensure content doesn't overflow during transition */\n  transition: 0.5s ease-in-out !important; /* Add smooth transition */\n  transition-property: visibility;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
